import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomInput from '../../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb';
import './inserir-evento.scss'
import 'bootstrap/dist/css/bootstrap.min.css';
import { PublicacaoParams } from '../../../../interfaces/publicacao.interface';

import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  Select,
  Tooltip,
  Stack,
  Checkbox,
  IconButton,
  RadioGroup,
  Radio,
  TagLabel,
  Tag,
  Wrap,
  TagCloseButton,
  WrapItem,
  Switch,
  HStack
} from '@chakra-ui/react';

import { ImageDropzone } from '../../../PublishContent/components/Banner/imageDropzone';
import { FileWithPath } from 'react-dropzone';
import CustomTextArea from '../../../../components/common/Textarea/textArea';
import Swal from 'sweetalert2';
import { listarCategoriasAtivas } from '../../../../api/categoria';
import * as api from '../../../../api/evento';
import { obterUsuario } from '../../../../api/usuario';
import { FaPlus } from 'react-icons/fa';
import { listarSecretariasAtivas } from '../../../../api/secretarias';

const InserirEvento: React.FC = () => {
  const navigate = useNavigate();
  const today = new Date().toISOString().split('T')[0];

  const [formValues, setFormValues] = useState<{
    titulo: { value: string; error: boolean };
    data: { value: typeof today; error: boolean };
    dataFim: { value: ''; error: boolean };
    dataInicioEvento: { value: ''; error: boolean };
    dataFimEvento: { value: ''; error: boolean };
    horaInicioEvento: { value: ''; error: boolean };
    horaFimEvento: { value: ''; error: boolean };
    numSemHorario: { value: boolean; error: boolean };
    imagem: { value: string; error: boolean };
    dscResumo: { value: string; error: boolean };
    secretariaId: { value: any[]; error: boolean };
    endereco: { value: string; error: boolean };
    enderecoInternet: { value: string; error: boolean };
    creditoAutorNoticia: { value: string; error: boolean };
    creditoAutorImagem: { value: string; error: boolean };
    descricaoImagem: { value: string; error: boolean };
    altImagem: { value: string; error: boolean };
    texto: { value: string; error: boolean };
    categoriaId: { value: string; error: boolean };
    paginaId: { value: any[]; error: boolean };
    usuarioId: { value: any; error: boolean };
    exigeAprovacao: { value: number; error: boolean };

  }>({
    titulo: { value: '', error: false },
    data: { value: today, error: false },
    dataFim: { value: '', error: false },
    dataInicioEvento: { value: '', error: false },
    dataFimEvento: { value: '', error: false },
    horaInicioEvento: { value: '', error: false },
    horaFimEvento: { value: '', error: false },
    numSemHorario: { value: false, error: false },
    imagem: { value: '', error: false },
    dscResumo: { value: '', error: false },
    secretariaId: { value: [], error: false },
    endereco: { value: '', error: false },
    enderecoInternet: { value: '', error: false },
    creditoAutorNoticia: { value: '', error: false },
    creditoAutorImagem: { value: '', error: false },
    descricaoImagem: { value: '', error: false },
    altImagem: { value: '', error: false },
    texto: { value: '', error: false },
    categoriaId: { value: '', error: false },
    paginaId: { value: [], error: false },
    usuarioId: { value: null, error: false },
    exigeAprovacao: { value: 0, error: false },
  });

  const [imageBase64, setImageBase64] = useState<string>('');
  const [paginas, setPaginas] = useState<any[]>([]);
  const [aprovadores, setAprovadores] = useState<any[]>([]);
  const [seqUsuario, setSeqUsuario] = useState<any[]>([]);
  const [selectedPages, setSelectedPages] = useState<number[]>([]);
  const [selectedUser, setSelectedUser] = useState<number | null>(null);
  const [categorias, setCategorias] = useState<any[]>([]);
  const [secretarias, setSecretarias] = useState<any[]>([]);
  const [secretariaSelecionada, setSecretariaSelecionada] = useState<number[]>([]);
  const [arquivo, setArquivo] = useState<any>();
  const [arquivoSelecionado, setArquivoSelecionado] = useState<File | null>(null);
  const [isLoadingButton, setLoadingButton] = useState<boolean>(false);
  const [inputValueTagUsuario, setInputValueTagUsuario] = useState('');
  const [tagUsuario, setTagUsuario] = useState<string>('');

  useEffect(() => {
    const storedUsuario = localStorage.getItem('dadosUsuario');
    if (storedUsuario) {
      try {
        const usuario = JSON.parse(storedUsuario);
        setSeqUsuario(usuario.seqUsuario);
        
        const fetchObterUsuario = async () => {
          try {
           const [data, ativas] = await Promise.all([
             obterUsuario(Number(usuario.seqUsuario)),
             listarSecretariasAtivas()
           ]);
           setSecretarias(
            data.usuarioSecretariaDTO?.length ? data.usuarioSecretariaDTO : ativas
          );
          } catch (error) {
            console.error("Erro ao obter usuario:", error);
          }
        };
  
        fetchObterUsuario();
  
      } catch (error) {
        console.error("Erro ao recuperar os dados do usuário:", error);
      }
    }

    const fetchCategorias = async () => {
      try {
        const data = await listarCategoriasAtivas();
        setCategorias(data);
      } catch (error) {
        console.error('Erro ao buscar categorias ativas:', error);
      }
    };

    fetchCategorias();
    fetchPaginas();
    fetchAprovadoresAtivos();
  }, []);

  const fetchPaginas = async () => {
    try {
      const data = await api.paginasAtivas();
      setPaginas(data);
    } catch (error) {
      console.error('Erro ao buscar páginas ativas:', error);
    }
  };

  const fetchAprovadoresAtivos = async () => {
    try {
      const data = await api.listarExecutores();
      setAprovadores(data);
    } catch (error) {
      console.error('Erro ao buscar lista de executores para aprovação:', error);
    }
  };

  const handleFieldChange = (field: keyof typeof formValues, value: any) => {
    setFormValues({ ...formValues, [field]: { value, error: false } });
  };

  const handleAddTagUsuario = () => {
    if (inputValueTagUsuario.trim()) {
      setTagUsuario(prevTagUsuario => {
        const newTag = inputValueTagUsuario.trim();
        return prevTagUsuario ? `${prevTagUsuario} ${newTag}` : newTag;
      });
      setInputValueTagUsuario('');
    }
  };

  const handleInputChangeTagUsuario = (e: any) => {
    const value = e.target.value;

    const valueWithoutSpaces = value.replace(/\s/g, '');
    if (valueWithoutSpaces && !valueWithoutSpaces.startsWith('@')) {
      setInputValueTagUsuario(`@${valueWithoutSpaces}`);
    } else {
      setInputValueTagUsuario(valueWithoutSpaces);
    }
  };

  const handleRemoveTagUsuario = (tagToRemove: string) => {
    setTagUsuario(prevTagUsuario => {
      const updatedTags = prevTagUsuario
        .split(' ')
        .filter(tag => tag !== tagToRemove)
        .join(' ');
      return updatedTags.trim();
    });
  };

  const handleCheckboxSecretaria = (codSecretaria: number, checked: boolean) => {
    setSecretariaSelecionada(prev =>
      checked ? Array.from(new Set([...prev, codSecretaria])) : prev.filter(id => id !== codSecretaria)
    );
  
    setFormValues(prev => {
      const current: number[] = Array.isArray(prev?.secretariaId?.value) ? prev.secretariaId.value : [];
      const next = checked
        ? Array.from(new Set([...current, codSecretaria]))
        : current.filter(id => id !== codSecretaria);
  
      return {
        ...prev,
        secretariaId: { ...prev.secretariaId, value: next, error: prev?.secretariaId?.error ?? false },
      };
    });
  };  

  const handleCheckboxChange = (seqPagina: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;

    setSelectedPages((prev) => {
      const updatedPages = isChecked ? [...prev, seqPagina] : prev.filter((id) => id !== seqPagina);
      return updatedPages;
    });

    setFormValues((prevValues: any) => {
      const updatedPaginaIdValue = isChecked
        ? [...prevValues.paginaId.value, seqPagina]
        : prevValues.paginaId.value.filter((id: number) => id !== seqPagina);

      return {
        ...prevValues,
        paginaId: { value: updatedPaginaIdValue },
        ordemBanner: { value: 0 },
      };
    });
  };

  const handleRadioChange = (seqUsuario: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;

    setSelectedUser(isChecked ? seqUsuario : null);

    setFormValues((prevValues: any) => {
      const updatedUsuarioIdValue = isChecked ? seqUsuario : null;

      return {
        ...prevValues,
        usuarioId: { value: updatedUsuarioIdValue },
      };
    });
  };

  const handleImageSelected = async (selected: FileWithPath | null) => {
    if (selected) {
      const isImage = selected.type.startsWith("image/");
      const isVideo = selected.type.startsWith("video/");
      const isAudio = selected.type.startsWith("audio/");

      setArquivo(selected);

      if (isImage || isVideo || isAudio) {
        setArquivoSelecionado(selected);
        setArquivo(selected);

      } else {
        console.error("Tipo de arquivo não suportado.");
      }
    } else {
      setArquivo(null);
      setArquivoSelecionado(null);
      console.warn("Nenhum arquivo selecionado.");
    }
  };

  const handleInputRadioChange = (field: string, value: any) => {
    if (field === 'exigeAprovacao' && value === 0) {
      setFormValues({
        ...formValues,
        [field]: { error: false, value },
        usuarioId: { value: null, error: false }
      });
    } else {
      setFormValues({
        ...formValues,
        [field]: { error: false, value }
      });
    }
  };

  const isFormValid = () => {
    const {
      titulo,
      data,
      dataInicioEvento,
      horaInicioEvento,
      horaFimEvento,
      categoriaId,
      paginaId,
      usuarioId,
      exigeAprovacao,
      numSemHorario
    } = formValues;
  
    if (exigeAprovacao.value === 1 && !usuarioId.value) {
      return false;
    }
  
    const horarioValido =
      numSemHorario.value ||
      (horaInicioEvento.value && horaFimEvento.value);
  
    const isValid =
      Boolean(titulo.value) &&
      Boolean(data.value) &&
      Boolean(dataInicioEvento.value) &&
      horarioValido &&
      Boolean(categoriaId.value) &&
      paginaId.value.length > 0 &&
      (exigeAprovacao.value === 0 || usuarioId.value != null);
  
    return isValid;
  };
  

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoadingButton(true);

    const {
      endereco,
      texto,
      creditoAutorImagem,
      descricaoImagem,
      altImagem,
      creditoAutorNoticia,
      dataFim,
      dataInicioEvento,
      dataFimEvento,
      horaInicioEvento,
      horaFimEvento,
      numSemHorario,
      secretariaId,
      categoriaId,
      paginaId,
      usuarioId,
      data
    } = formValues;

    const pendencia = usuarioId.value
      ? {
        codPendencia: 1,
        seqSolicitante: seqUsuario,
        seqExecutor: usuarioId.value,
      }
      : null;

    let codSituacao = 1;
    ;

    if (data.value) {
      const dataDaPublicacao = data.value;
      const diaDeHoje = new Date().toISOString().split("T")[0];

      if (pendencia) {
        codSituacao = 5;
      } else if (dataDaPublicacao > diaDeHoje) {
        codSituacao = 1;
      } else if (dataDaPublicacao === diaDeHoje) {
        codSituacao = 2;
      }
    } else {
      codSituacao = 2;
    }

    const eventoDiaInteiro = formValues.numSemHorario.value;

    const horaInicio = eventoDiaInteiro
      ? null
      : formValues.horaInicioEvento.value || null;

    const horaFim = eventoDiaInteiro
      ? null
      : formValues.horaFimEvento.value || null;

    const params: PublicacaoParams = {
      codTipoPublicacao: 2,
      nomePublicacao: formValues.titulo.value || null,
      datPublicacao: formValues.data.value || null,
      datDespublicar: dataFim.value ? formValues.dataFim.value : null,
      seqUsuario: seqUsuario,
      binPublicacao: '',
      dscResumo: formValues.dscResumo.value || null,
      dscTags: null,
      numRegistro: 1,
      urlBin: formValues.enderecoInternet.value,
      codSituacaoPubli: codSituacao,
      dscPublicacao: texto.value || null,
      dscCreditoImagem: creditoAutorImagem.value || null,
      dscCreditoNoticia: creditoAutorNoticia.value || null,
      dscDescricaoImagem: descricaoImagem.value || null,
      dscAltImagem: altImagem.value || null,
      seqCategoria: Number(categoriaId.value) || null,
      conteudoPaginaDTO: paginaId.value.map((id: any) => ({
        seqPagina: Number(id),
        numOrdem: 0,
      })),
      pendencia: pendencia,
      numAprovacao: pendencia ? 1 : 0,
      dscCitacaoUsuario: tagUsuario,
      numAprovado: 0,
      datInicioEvento: dataInicioEvento.value ? formValues.dataInicioEvento.value : null,
      datFimEvento: dataFimEvento.value ? formValues.dataFimEvento.value : null,
      contasRedeSocial: null,
      dscHoraInicioEvento: horaInicio,
      dscHoraFimEvento: horaFim,
      numSemHorario: eventoDiaInteiro ? 1 : 0,
      dscEnderecoEvento: endereco.value || null,
      conteudoSecretariaDTO: secretariaId.value.map((id: number) => ({
        codSecretaria: id,
      })),
    };

    try {
      if (arquivoSelecionado) {
        const formData = new FormData();
        formData.append("file", arquivoSelecionado);

        const fileExtension = arquivoSelecionado.name.split('.').pop();
        let fileNameToSend = 'evento';

        if (
          fileExtension &&
          !fileNameToSend.toLowerCase().endsWith(`.${fileExtension.toLowerCase()}`)
        ) {
          fileNameToSend = `${fileNameToSend}.${fileExtension}`;
        }

        const nomePasta = 'publicacoes';

        formData.append("fileName", fileNameToSend);
        formData.append("folderName", nomePasta);

        const cdnData = await api.inserirEventoNoCdn(formData);

        let cdnUrl = "";
        if (typeof cdnData === "string") {
          const regex = /(https?:\/\/[^\s]+)/g;
          const match = cdnData.match(regex);
          if (match && match[0]) {
            cdnUrl = match[0];
          } else {
            throw new Error("URL não encontrada na resposta do CDN.");
          }
        } else if (cdnData && cdnData.url) {
          cdnUrl = cdnData.url;
        } else {
          throw new Error("Resposta do CDN inesperada.");
        }

        params.binPublicacao = cdnUrl;
      }

      await api.inserirPublicacao(params);
      setLoadingButton(false);

      Swal.fire({
        icon: "success",
        title: "Sucesso!",
        text: "Evento inserido com sucesso.",
        confirmButtonColor: "#1789FC",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/cms/publicacao/evento");
      });
    } catch (error) {
      setLoadingButton(false);
      console.error("Erro ao inserir evento:", error);
      Swal.fire({
        icon: "error",
        title: "Ocorreu um erro!",
        text: "Erro ao inserir evento. Tente novamente mais tarde.",
        confirmButtonColor: "#1789FC",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/cms/publicacao/eventos");
      });
    }
  };

  return (
    <Flex
      direction="column"
      padding='40px'
      background-color='#fafafa'
      width='100%'
      height={formValues.exigeAprovacao.value === 1 ? '100%' : '100%'}
      overflow='hidden'
    >
      <SettingsBreadcrumb />
      <Heading mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Criar Evento
      </Heading>
      <Box m="40px 0" w="100%">
        <form onSubmit={handleFormSubmit}>
          <div className="row">
            <div className="col-md-6 mb-4">
              <FormControl isRequired isInvalid={formValues.titulo.error}>
                <FormLabel htmlFor="event-category" mb="8px">Categoria do Evento</FormLabel>
                <Select
                  id="event-category"
                  placeholder='Selecione uma Categoria'
                  borderColor="gray.300"
                  _hover={{ borderColor: 'blue.500' }}
                  value={formValues.categoriaId.value}
                  onChange={(e) => handleFieldChange('categoriaId', e.target.value)}
                >
                  {categorias.length > 0 ? (
                    categorias.map(categoria => (
                      <option key={categoria.seqCategoria} value={categoria.seqCategoria}>
                        {categoria.dscCategoria}
                      </option>
                    ))
                  ) : (
                    ''
                  )}
                </Select>
              </FormControl>
            </div>

            <div className="col-md-6 mb-4">
              <FormControl isRequired isInvalid={formValues.titulo.error}>
                <FormLabel htmlFor="event-title" mb="8px">Título do Evento</FormLabel>
                <CustomInput
                  id="event-title"
                  value={formValues.titulo.value}
                  onChange={(e: any) => handleFieldChange('titulo', e.target.value)}
                  placeholder="Digite um título"
                />
              </FormControl>
            </div>

            <div className="col-md-6 mb-4">
              <FormControl mb={'24px'}>
                <FormLabel mb="8px">Endereço do Evento</FormLabel>
                <CustomInput
                  value={formValues.endereco.value}
                  onChange={(e) => handleFieldChange('endereco', e.target.value)}
                  placeholder="Digite um endereço"
                />
              </FormControl>

              <div className="row" style={{ marginBottom: '24px' }}>
                <div className="col-md-6">
                  <FormControl isRequired>
                    <FormLabel mb="8px">Data início do evento</FormLabel>
                    <CustomInput
                      id="event-insert-start-date"
                      type="date"
                      value={formValues.dataInicioEvento.value}
                      onChange={(e: any) => handleFieldChange('dataInicioEvento', e.target.value)}
                    />
                  </FormControl>
                </div>

                <div className="col-md-6">
                  <FormControl>
                    <FormLabel mb="8px">Data fim do evento</FormLabel>
                    <CustomInput
                      id="event-insert-end-date"
                      type="date"
                      value={formValues.dataFimEvento.value}
                      onChange={(e) => handleFieldChange('dataFimEvento', e.target.value)}
                    />
                  </FormControl>
                </div>
              </div>
              <Stack spacing={4} mb='24px'>
                <FormControl display="flex" alignItems="center">
                <Switch
                  id="dia-todo"
                  isChecked={formValues.numSemHorario.value}
                  onChange={e => {
                    const isChecked = e.target.checked;

                    setFormValues(prev => ({
                      ...prev,
                      numSemHorario: { value: isChecked, error: false },
                      horaInicioEvento: { value: isChecked ? '' : prev.horaInicioEvento.value, error: false },
                      horaFimEvento: { value: isChecked ? '' : prev.horaFimEvento.value, error: false }
                    }));
                  }}
                />
                  <FormLabel htmlFor="dia-todo" mb="0" ml="8px">
                    Evento o dia todo
                  </FormLabel>
                </FormControl>

                <HStack spacing={6} width="100%">
                  <FormControl flex="1" isRequired={!formValues.numSemHorario.value}>
                    <FormLabel mb="8px">Horário de início</FormLabel>
                    <CustomInput
                      type="time"
                      value={formValues.horaInicioEvento.value}
                      isDisabled={formValues.numSemHorario.value}
                      onChange={e =>
                        handleFieldChange('horaInicioEvento', e.target.value)
                      }
                    />
                  </FormControl>

                  <FormControl flex="1" isRequired={!formValues.numSemHorario.value}>
                    <FormLabel mb="8px">Horário de término</FormLabel>
                    <CustomInput
                      type="time"
                      value={formValues.horaFimEvento.value}
                      isDisabled={formValues.numSemHorario.value}
                      onChange={e =>
                        handleFieldChange('horaFimEvento', e.target.value)
                      }
                    />
                  </FormControl>
                </HStack>
              </Stack>

              <div className="col-md-12 mb-4">
                <FormControl className="mb-4">
                  <FormLabel mb="8px">Imagem miniatura</FormLabel>
                  <ImageDropzone
                    onImageSelected={handleImageSelected}
                    base64={imageBase64}
                    height={300}
                    uploadMessage={`Arraste a imagem do evento aqui ou clique para selecionar.`}
                  />
                    {arquivoSelecionado && (
                      <FormControl isRequired className="mt-3">
                        <FormLabel mb="8px">Crédito/Autor da imagem</FormLabel>
                        <CustomInput
                          placeholder="Digite um crédito ou autor da imagem"
                          value={formValues.creditoAutorImagem.value}
                          onChange={(e) => handleFieldChange('creditoAutorImagem', e.target.value)}
                        />
                      </FormControl>
                    )}
                    {arquivoSelecionado && (
                      <>
                        <FormControl className="mt-3">
                          <FormLabel mb="8px">Descrição de imagem</FormLabel>
                          <CustomInput
                            placeholder="Digite o texto alternativo da imagem"
                            value={formValues.altImagem.value}
                            onChange={(e) => handleFieldChange('altImagem', e.target.value)}
                          />
                        </FormControl>
                      </>
                    )}
                </FormControl>
              </div>

              <FormControl>
                <Flex justify="space-between" align="center" mb="8px">
                  <FormLabel mb="8px">
                    Escolha em quais páginas o evento deve aparecer <span style={{ color: 'red' }}>*</span>
                  </FormLabel>
                </Flex>
                <div className="input-radio-lista">
                  <Stack spacing={5}>
                    {paginas.length > 0 ? (
                      paginas.map((pagina: any) => (
                        <Flex key={pagina.seqPagina} align="center" justify="space-between" direction={{ base: 'column', md: 'row' }}>
                          <Checkbox
                            className="checkPaginasNoticia"
                            isChecked={selectedPages.includes(pagina.seqPagina)}
                            onChange={(e) => handleCheckboxChange(pagina.seqPagina, e)}
                          >
                            {pagina.nomPagina}
                          </Checkbox>
                        </Flex>
                      ))
                    ) : (
                      <p>Não há páginas disponíveis.</p>
                    )}
                  </Stack>
                </div>
              </FormControl>
            </div>

            <Box className="col-md-6">
              <div className="row">
                <div className="col-md-6 mb-4">
                  <FormControl isRequired>
                    <FormLabel mb="8px">Data para Publicação</FormLabel>
                    <CustomInput
                      id="event-insert-publication-date"
                      type="date"
                      value={formValues.data.value}
                      onChange={(e) => handleFieldChange('data', e.target.value)}
                      min={today}
                    />
                  </FormControl>
                </div>
                <div className="col-md-6 mb-4">
                  <FormControl>
                    <FormLabel mb="8px">Data fim para Publicação</FormLabel>
                    <CustomInput
                      id="event-insert-unpublish-date"
                      type="date"
                      value={formValues.dataFim.value}
                      onChange={(e) => handleFieldChange('dataFim', e.target.value)}
                      min={today}
                    />
                  </FormControl>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 mb-4">
                  <FormControl>
                    <FormLabel mb="8px">Resumo do evento</FormLabel>
                    <CustomTextArea
                      placeholder="Digite um resumo"
                      value={formValues.dscResumo.value}
                      onChange={(e) => handleFieldChange('dscResumo', e.target.value)}
                    />
                  </FormControl>
                </div>
              </div>

              <FormControl>
                <FormLabel mb="8px">Tags</FormLabel>
                <div style={{ display: 'flex' }}>
                  <CustomInput
                    value={inputValueTagUsuario}
                    onChange={handleInputChangeTagUsuario}
                    placeholder="Digite uma tag"
                    maxLength={100}
                  />
                  <Button onClick={handleAddTagUsuario} ml="2">
                    <FaPlus />
                  </Button>
                </div>
              </FormControl>

              <div className="rolagem-hashtag mb-2">
                <Wrap spacing="2px">
                  {tagUsuario.trim() && tagUsuario.split(' ').map((tag, index) => (
                    <WrapItem key={index}>
                      <Tag variant="solid" colorScheme="blue" maxW="180px" isTruncated>
                        <TagLabel>{tag}</TagLabel>
                        <TagCloseButton onClick={() => handleRemoveTagUsuario(tag)} />
                      </Tag>
                    </WrapItem>
                  ))}
                </Wrap>
              </div>
              <FormControl marginBottom={'24px'}>
                <FormLabel mb="8px">Endereço de Internet para o evento</FormLabel>
                <CustomInput
                  placeholder="Digite um endereço de internet"
                  value={formValues.enderecoInternet.value}
                  onChange={(e) => handleFieldChange('enderecoInternet', e.target.value)}
                />
              </FormControl>

              <div className="row mt-2">
              <FormControl className='mb-4 mt-1'>
              {secretarias.length > 0 && (
                <>
                  <Flex justify="space-between" align="center">
                    <FormLabel mb="8px">
                      Associe o usuário a uma secretaria (opcional)
                    </FormLabel>
                  </Flex>

                  <Box
                    border="1px solid"
                    borderColor="gray.300"
                    borderRadius="md"
                    p={3}
                  >
                    <Box overflow="hidden">
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <colgroup>
                          <col style={{ width: '60px' }} />
                          <col style={{ width: '120px' }} />
                          <col />
                        </colgroup>
                        <thead>
                          <tr>
                            <th style={{ textAlign:'center', padding:'8px', borderBottom:'1px solid #ddd' }}></th>
                            <th style={{ textAlign:'left',   padding:'8px', borderBottom:'1px solid #ddd', color:'gray' }}>Código</th>
                            <th style={{ textAlign:'left',   padding:'8px', borderBottom:'1px solid #ddd', color:'gray' }}>Secretaria</th>
                          </tr>
                        </thead>
                      </table>
                    </Box>

                    <Box 
                      className="sidebar-checkbox-pagina"
                      overflowX="auto"
                      overflowY={secretarias.length > 5 ? 'auto' : 'visible'}
                      maxH={secretarias.length > 5 ? '240px' : 'unset'}
                    >
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <colgroup>
                          <col style={{ width: '60px' }} />
                          <col style={{ width: '120px' }} />
                          <col />
                        </colgroup>
                        <tbody>
                        {secretarias.map((secretaria: any) => {
                          const cod = Number(secretaria.codSecretaria);
                          const nome = secretaria.secretariasDTO?.dscSecretaria ?? secretaria.dscSecretaria ?? '—';

                          return (
                            <tr key={cod}>
                              <td style={{ textAlign: "center", padding: "8px", borderBottom: "1px solid #ddd" }}>
                                <Checkbox
                                  className="checkCategorias"
                                  isChecked={secretariaSelecionada.includes(cod)}
                                  onChange={(e) => handleCheckboxSecretaria(cod, e.target.checked)}
                                />
                              </td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{cod}</td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{nome}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                      </table>
                    </Box>
                  </Box>
                </>
              )}
            </FormControl>
                <div className="col-md-6 mb-4">
                  <FormControl isRequired>
                    <FormLabel mb="8px">Exige aprovação</FormLabel>
                    <RadioGroup
                      onChange={(value) => handleInputRadioChange('exigeAprovacao', Number(value))}
                      value={formValues.exigeAprovacao.value.toString()}
                    >
                      <Radio value="1" mr={5}>Sim</Radio>
                      <Radio value="0">Não</Radio>
                    </RadioGroup>
                  </FormControl>
                </div>

                {formValues.exigeAprovacao.value === 1 && (
                  <div className="col-md-6 mb-4">
                    <FormControl isRequired>
                      <Flex justify="space-between" align="center" mb="8px">
                        <FormLabel>Selecione o aprovador desta publicação</FormLabel>
                      </Flex>
                      <div className="input-radio-lista">
                        <Stack spacing={5}>
                          {aprovadores.length > 0 ? (
                            aprovadores.map((aprovador: any) => (
                              <Flex key={aprovador.seqUsuario}>
                                <Radio
                                  className="radioAprovadoresNoticia"
                                  value={aprovador.seqUsuario.toString()}
                                  isChecked={selectedUser === aprovador.seqUsuario}
                                  onChange={(e) => handleRadioChange(aprovador.seqUsuario, e)}
                                >
                                  {aprovador.dscNome}
                                </Radio>
                              </Flex>
                            ))
                          ) : (
                            <p>Não há lista de aprovadores disponíveis.</p>
                          )}
                        </Stack>
                      </div>
                    </FormControl>
                  </div>
                )}
              </div>
            </Box>
          </div>

          <Flex mt="35px" justifyContent="end">
            <Button
              m="6px"
              onClick={() => navigate('/cms/publicacao/noticia')}
            >
              Desistir
            </Button>
            <Button
              type="submit"
              m="6px"
              color="#FFF"
              bgColor="#1665D8"
              _hover={{ opacity: 0.8 }}
              isDisabled={!isFormValid()}
              isLoading={isLoadingButton}
              loadingText="Criando Evento..."
            >
              {formValues.exigeAprovacao.value === 1
                ? 'Enviar para Aprovação'
                : 'Criar Evento'}
            </Button>
          </Flex>
        </form>
      </Box>
    </Flex>
  );
};

export default InserirEvento;
